import * as React from "react";
import Radio from "@mui/material/Radio";
import MUIRadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function RadioGroup({
  value,
  setValue,
  name,
  options,
  label,
  FormControlProps,
  RadioGroupProps,
}) {
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  if (value === undefined) {
    const defaultOption = options.filter((option) => option.default)[0];
    value = defaultOption != undefined ? defaultOption.value : "";
  }
  return (
    <FormControl {...(FormControlProps || {})}>
      <FormLabel>{label}</FormLabel>
      <MUIRadioGroup
        name={name}
        value={value}
        onChange={handleChange}
        {...(RadioGroupProps || {})}
        row
      >
        {options.map((option, i) => (
          <FormControlLabel
            key={i}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </MUIRadioGroup>
    </FormControl>
  );
}
